import { useContext } from 'react';
import MainLayout from '../components/MainLayout';
import AddNewsletter from '../components/AddNewsletter';
import PageHeader from '../components/PageHeader';
import '../pages/DiscoverPage.css';
import { useFlowFormGlobal, FlowFormLeaveContext } from 't-lib-ui/structure';
import { RouterContext, goTo } from 't-lib-ui/router';
import { sidebarLeaveHandler } from '../components/LeftSidebarFocus';

const AddNewsletterPage: React.FC = () => {
  useFlowFormGlobal('.flowForm.mainForm');
  const routerCtx = useContext(RouterContext);

  return (
    <FlowFormLeaveContext.Provider value={sidebarLeaveHandler}>
      <MainLayout
        selectedFeed="add"
        right={({ onExpand }) => (
          <div className="discoverPage">
            <PageHeader title="Add newsletter" onMenu={onExpand} onBack={() => goTo(routerCtx, '/a/add')} />
            <AddNewsletter />
          </div>
        )}
        startWithLeftCollapsed={typeof window !== 'undefined' && window.innerWidth <= 750}
      />
    </FlowFormLeaveContext.Provider>
  );
};

export default AddNewsletterPage;
